<template>
   <div class="title-wrapper" id="block_display_title">
      <span class="title-label">Program Block:</span>
      <input @keyup="handleTitleChange" type="text" id="title" placeholder="Untitled" v-model="title">
   </div>
</template>

<script>
import BaseTitle from './../block_detail/BaseTitle';

import { mapActions, mapState } from 'vuex';

export default {
   extends: BaseTitle,

   data() {
      return {
         newTitle: this.title
      }
   },

   props: {
      title: String
   },

   computed: {
      // ...mapState('program_block', [
      //    'blockTitle'
      // ])
   },

   methods: {
      ...mapActions('program_block', ['changeBlockTitle']),

      handleTitleChange() {
         this.changeBlockTitle({newTitle: this.title});
      }
   }
}
</script>
